import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/percepciones-parametros-diversos';

/**
 * GET lista
 */
export const getPercepcionesParametrosDiversos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET por ID
 */
export const getPercepcionParametroDiverso = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 */
export const postPercepcionParametroDiverso = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH
 */
export const patchPercepcionParametroDiverso = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE
 */
export const deletePercepcionParametroDiverso = async (id) => {
  try {
    await API.delete(`${baseURI}/${id}`);
    onSuccess(null, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR
 */
export const autorizarPercepcionParametroDiverso = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, {
      estados_globales: ESTATUS_AUTORIZADO,
    });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
